import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CustomDomainsSetup = lazy(() =>
  import("@scenes/CustomDomains/components/CustomDomainsSetup").then((module) => ({
    default: module.CustomDomainsSetup,
  }))
);

export const customDomainsDetailsNRO: NavigationRoutingObject = {
  section: "settings",
  Component: CustomDomainsSetup,
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("custom-domains-details-nro-heading", "SMS/RCS and Messaging Apps Domains"),
  pageNameForTracking: () => "SMS/RCS and Messaging Apps Domains",
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  getDeveloperNavigationAllowed: ({ hasPermission }) => {
    return hasPermission("company", {
      permission: "editDomainSettings",
    });
  },
  // NOTE: if you want to add an 'additionalSearchTerm', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchTerm' and follow the prompts
  additionalSearchTerms: () => [],
  // NOTE: when adding additionalSearchableFeatures make sure one of the
  // query params of the feature matches the key name of the feature.
  // NOTE 2: if you want to add an 'additionalSearchableFeature', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchableFeature' and follow the prompts
  additionalSearchableFeatures: () => ({}),
};
